var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.isMobile && _vm.iframeTokenValid ? '100%' : '' })},[_c('DocumentDetailMenu',[_c('template',{slot:"left-section"},[_c('zt-icon',{attrs:{"name":"angle-left"}})],1),_c('template',{slot:"right-section"},[_c('zt-icon',{attrs:{"name":"download-paper-outline"}})],1)],2),_c('DocumentDetailComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }